export default {"src":"/_next/static/media/youtube-green.ad9871d2.svg","height":16,"width":20};